<template>
<div class="overlay" >
  <div class="upload-image-wrapper" style="width:36.5em;max-height:39em;overflow:auto">
   <div class="close"><button v-on:click="closeShowUploadImageDialog">X</button></div>
   <div v-if="!$store.changeDeleteImage" class="upload-image-head">Upload Media</div>
   <div v-else class="update-image-head">Update Image</div>

   <div class="upload-image-gallery" v-if="$store.dialogTreeGalleryStatus" style="width:280px">
     <div class="gallery" style="max-height: 14em;width: 34em;overflow: auto;margin-bottom: 14px;display: flex;flex-wrap: wrap;
     justify-content: center;">

     <div v-for="(img,index) in $store.uploadDialogtreeImg" :key="index" style="display:contents;">
     <div v-if="$store.dialogTreeGalleryStatus"  style="display:flex;border-style: solid;border-color: dodgerblue;margin: 5px;">
         <img @click="uploadimgSrc(img.src,img.id)" type="file" :src="img.src" alt="" style="width:100px;height:100px" class="hoverable">
      </div>
      </div>
    </div>
   </div>

    <div class="upload-image-body" v-if="$store.imageChosen" style="width:35em">

      <img v-if="!$store.dialogTreeGalleryStatus"  v-bind:src="$store.uploadDialogImgSrc" id="image-view-placeholder" width="180px" height="150px">
      
      <input type="file" name="pic" accept="image/*" style="display:none" v-on:change="readURL($event)" ref="imageFile">

      <div v-if="$store.changeDeleteImage" class="delete-change-image-buttons" style="display:flex;width:27.5em;margin-left:4em;margin-top:10px">
        <button type="button" name="change" v-on:click="$store.changeDeleteImage=false;$store.dialogTreeGalleryStatus=true" >Change</button>
        <button type="button" name="Delete" v-on:click="deleteGalleryImage()" style="margin-left:100px">Delete</button>

      </div>

      <div v-else class="upload-image-buttons" style="display: flex;width: 27.5em;">
        <button type="button" name="browse" v-on:click="browse" :style="{display:imageBrowseButtonDisplay,margin:marginBrowseImgBtn}" >Browse Image</button>
        <button style="margin-left:100px" @click="uploadingGalleryImages()" v-if="$store.dialogTreeGalleryStatus" >Load More</button>
        <button type="button" name="Upload" v-on:click="upload" :disabled="imageUploadButtonDisabled" :style="{display:imageUploadButtonDisplay}" >{{imageUploadButtonContent}}</button>
        <button class="changeimg" type="button" name="Upload_img" v-on:click="uploadImgGalleryPictures($store.galleryimageId)" :disabled="imgUploadButtonDisabled" :style="{display:imgUploadButtonDisplay}" >{{imgUploadButtonContent}}</button>
      </div>
    </div>

    <div v-if="$store.videoGalleryStatus" class="video-gallery" style="max-height:24em;overflow:auto;margin-top:20px;">
     <div  v-for="(vid,index) in $store.uploadDialogtreeVid" :key="index"  style="max-height:24em">
     <video :src="vid.src" id="video-player" controls></video>
     <button  @click="uploadVidSrc(vid.src,vid.id)">select Video</button>
   </div>
   </div>

    <div v-if="$store.videoChosen && !$store.changeDeleteImage && !$store.answerImageUploadDialog" class="upload-video-body">
      <!-- <p>Allowed formats are mp4 and mkv.</p> -->
     <video v-if="!$store.videoGalleryStatus && !$store.statusinit" v-bind:src="$store.uploadDialogVidSrc" id="video-player" controls></video>
     <input id="video-player-input" type="file" name="" accept="video/*" style="display:none" v-on:change="videoBrowseButtonChange($event)" ref="videoFile">
      <div v-if="$store.changeDeleteVideo" class="delete-change-video-buttons">
        <button type="button" name="Delete" v-on:click="deleteGalleryImage()" >Delete</button>
      </div>
      <div v-else class="upload-video-buttons" style="display:flex;width:27.5em">
        <button type="button" name="browseVideo" v-on:click="browseVideo" :style="{display:videoBrowseButtonDisplay,margin:marginBrowseBtn}" >Browse video</button>
        <button v-if="$store.videoGalleryStatus" style="margin-left:100px" @click="uploadingGalleryVideo()"  >Load More</button>
        <button type="button" name="UploadVideo" v-on:click="uploadVideo" :disabled="videoUploadButtonDisabled" :style="{display:videoUploadButtonDisplay}" >{{videoUploadButtonContent}}</button>
        <button class="changevid" type="button" name="Upload_vid" v-on:click="uploadVidfromGallery($store.galleryVideoId)" :disabled="vidUploadButtonDisabled" :style="{display:vidUploadButtonDisplay}" >upload</button>
      </div>
   </div>
   
   <div v-if="$store.linkChosen && !$store.changeDeleteImage && !$store.answerImageUploadDialog" id="video-link-inputbox" class="input-field">
    <div class="video-link-add-btn btn" v-on:click="addVideoLink">
      <span>Add</span>
    </div>
    <input type="text" id="video-link-input" v-model="videoLink" name="video-link-input">
    <label for="video-link-input">Add a link</label>
   </div>

   <div v-if="errorOccured" style="color:red;font-size:12px">oops! some error occured!!!</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'UploadImage',
  data() {
  return {   
  cursorId:"",
  vidUploadButtonDisabled:true,
  vidUploadButtonDisplay:"none",
  imgUploadButtonDisabled: true,
  imgUploadButtonDisplay:"none",
  imgUploadButtonContent:"upload",  
  imageBrowseButtonDisplay:'block',
  imageUploadButtonDisplay:'none',
  imageUploadButtonDisabled:false,
  imageUploadButtonContent:"Upload",
  file:'',
  errorOccured:false,
  videoBrowseButtonDisplay:'block',
  videoUploadButtonDisplay:'none',
  videoUploadButtonDisabled:false,
  videoUploadButtonContent:"Upload",
  videoLink:'',
  marginBrowseBtn: "20px 10px 0px 10px",
  marginBrowseImgBtn: "0px 10px 0px 10px"
  }
  },

mounted(){

  if(this.$store.uploadDialogtreeImg.length == 0){
      this.uploadingGalleryImages();
      console.log("initial Image Gallery upload finished")
    }
  if(this.$store.uploadDialogtreeVid.length == 0){
    this.uploadingGalleryVideo();
    console.log("initial Video Gallery upload finished")
  }
  this.galleryStatus();
  },

methods : {
     browse(){
     this.$refs.imageFile.click();
     this.$store.imageChosen=true;
     },
     browseVideo(){
       this.$refs.videoFile.click();
       this.$store.videoChosen=true;
     },
     readURL(input) {
       var vm = this;
       var file= input.target.files[0]; //get the type of input by user image or video
       var fileType = file.type
       if(fileType.includes("video")){
         input=input.path[0]
       if (input.files && input.files[0]) {
           var reader = new FileReader();
           reader.onload = function (e) {
               vm.$store.uploadDialogVidSrc = e.target.result;
               vm.$store.videoGalleryStatus = false;
           }

           reader.readAsDataURL(input.files[0]);
       }  
       }else{
       if (input.target.files && input.target.files[0]) {
           var reader = new FileReader();
           reader.onload = function (e) {
               vm.$store.uploadDialogImgSrc = e.target.result;
               vm.$store.dialogTreeGalleryStatus = false;
              //  vm.imageBrowseButtonDisplay = 'none';
               vm.imageUploadButtonDisplay = 'block';
           }
           reader.readAsDataURL(input.target.files[0]);
       }
       }
   },
   videoBrowseButtonChange(event) {
    // this.videoBrowseButtonDisplay = 'none';
    this.videoUploadButtonDisplay = 'block';
    this.readURL(event)
},
   upload(){
    this.file = this.$refs.imageFile.files[0];
    var formData = new FormData();
    formData.append('file', this.file);
    this.uploadButtonContent = "Uploading..." ;
    this.uploadButtonDisabled = true;
    if(this.$store.uploadingInstructionImage){
      if(this.$store.editingInstImg){

        var attachArray = this.$store.instructionAttachments[this.$store.currentDialogId];
        var attach = attachArray[this.$store.editingInstImgIndex];
        var vm = this;
        var instructionId = this.$store.currentDialogId;
        this.$http.put("/dialogs/" + this.$store.currentDialogId + "/attachments",
             formData,
              {
                headers:{
                  'content-Type':'multipart/form-data',
                  'index':vm.$store.editingInstImgIndex
                }
              }).then(function(r){

                var obj = {
                      type:"image",
                      data:vm.$store.uploadDialogImgSrc,
                      id:r.data.id
                };

               vm.$store.instructionAttachments = vm.$store.instructionAttachments ? vm.$store.instructionAttachments : {};
               var instAttachments = vm.$store.instructionAttachments[instructionId] ? vm.$store.instructionAttachments[instructionId] : [];
               instAttachments.splice(vm.$store.editingInstImgIndex,1,obj);
               vm.$set(vm.$store.instructionAttachments,instructionId,instAttachments);
                    vm.$store.showUploadImageDialog=false;
                    vm.$store.answerImageUploadDialog=false;
                    vm.$store.uploadDialogImgSrc='';
                    vm.uploadButtonDisabled = false;
                    vm.uploadButtonContent = "Upload";
                    vm.$store.imageChosen=false;
                    vm.updateDialog(vm.$store.currentDialogRef.dialog.id)
                    vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
              }).catch(function(){
                    vm.errorOccured=true;
                    vm.uploadButtonDisabled = false;
                    vm.uploadButtonContent = "Upload";
              });


      }else{
        var attachArray = this.$store.instructionAttachments[this.$store.currentDialogId] ? this.$store.instructionAttachments[this.$store.currentDialogId] : [];
        var vm = this;
        var instructionId = this.$store.currentDialogId;
          this.$http.post("/dialogs/" + this.$store.currentDialogId + "/attachments",
             formData,
              {
                headers:{
                  'content-Type':'multipart/form-data',
                  'index':attachArray.length
                }
              }).then(function(r){
                    var obj = {
                      type:"image",
                      data:vm.$store.uploadDialogImgSrc,
                      id:r.data.id
                    };
                    vm.$store.showUploadImageDialog=false;
                    vm.$store.answerImageUploadDialog=false;
                    vm.$store.uploadDialogImgSrc='';
                    vm.uploadButtonDisabled = false;
                    vm.uploadButtonContent = "Upload";
                    vm.$store.imageChosen=false;
                    vm.updateDialog(vm.$store.currentDialogRef.dialog.id)
                    vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
              }).catch(function(){
                    vm.errorOccured=true;
                    vm.uploadButtonDisabled = false;
                    vm.uploadButtonContent = "Upload";
              });

      }
    } else{

    var vm = this;

    if(!vm.$store.dialogHasAttachment[vm.$store.currentDialogId]){
      this.$http.post("/dialogs/" + this.$store.currentDialogId + "/attachments",
      formData,
      {
        headers:{
          'content-Type':'multipart/form-data'
        }
      }).then(function(r){
        vm.$set(vm.$store.dialogHasAttachment,vm.$store.currentDialogId,r.data.id);

        vm.$set(vm.$store.dialogHasImage,vm.$store.currentDialogId,vm.$store.uploadDialogImgSrc);
        vm.$store.showUploadImageDialog=false;
        vm.$store.answerImageUploadDialog=false;
        vm.$store.uploadDialogImgSrc='';
        vm.uploadButtonDisabled = false;
        vm.uploadButtonContent = "Upload";
        vm.$store.imageChosen=false;
        vm.updateDialog(vm.$store.currentDialogRef.dialog.id)
        vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
      }).catch(function(){
        vm.errorOccured=true;
        vm.uploadButtonDisabled = false;
        vm.uploadButtonContent = "Upload";
      });
    }
    else{
      this.$http.put("/dialogs/" + this.$store.currentDialogId + "/attachments",
      formData,
      {
        headers:{
          'content-Type':'multipart/form-data'
        }
      }).then(function(r){
        vm.$set(vm.$store.dialogHasAttachment,vm.$store.currentDialogId,r.data.id);
        vm.$set(vm.$store.dialogHasImage,vm.$store.currentDialogId,vm.$store.uploadDialogImgSrc);
        vm.$store.showUploadImageDialog=false;
        vm.$store.answerImageUploadDialog=false;
        vm.$store.uploadDialogImgSrc='';
        vm.uploadButtonDisabled = false;
        vm.uploadButtonContent = "Upload";
        vm.$store.imageChosen=false;
        vm.updateDialog(vm.$store.currentDialogRef.dialog.id)
        vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
      })
      .catch(function(){
         vm.uploadButtonDisabled = false;
         vm.uploadButtonContent = "Upload";
      });
    }

    }
   },
   updateDialog(dialogId){
     this.$store.getDialogById(dialogId).then((response) => {
        this.$store.currentDialogRef.dialog.attachments= response.attachments
    })
   },
   uploadVideo(){
    var vm = this;
    if(this.$refs.videoFile.files[0].type.indexOf("video") < 0){
      vm.$store.showUploadImageDialog=false;
      vm.$store.answerImageUploadDialog=false;
      vm.videoUploadButtonDisabled = false;
      vm.$store.videoChosen = false;
      vm.$store.changeDeleteVideo = false;
      vm.videoUploadButtonContent = "Upload";
      return; 
    }
    var vm=this;
    var instructionId = vm.$store.currentDialogId;
    vm.videoUploadButtonContent = "Uploading..." ;
    vm.videoUploadButtonDisabled = true;
    var videoArray = this.$store.instructionAttachments[this.$store.currentDialogId] ? this.$store.instructionAttachments[this.$store.currentDialogId] : [];
    vm.file = vm.$refs.videoFile.files[0];
    var formData = new FormData();
    formData.append('file', vm.file);

    vm.$http.post("/dialogs/" + vm.$store.currentDialogId + "/attachments",
    formData,
    {
      headers:{
        'content-Type':'multipart/form-data',
        'index': videoArray.length
      }
    }).then(function(r){
          var obj = {
            type:"video",
            data:vm.$store.uploadDialogVidSrc,
            id:r.data.id
          };
        vm.$store.showUploadImageDialog=false;
        vm.$store.answerImageUploadDialog=false;
        vm.videoUploadButtonDisabled = false;
        vm.$store.videoChosen = false;
        vm.$store.changeDeleteVideo = false;
        vm.videoUploadButtonContent = "Upload";
        vm.updateDialog(vm.$store.currentDialogRef.dialog.id)
        vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);

    }).catch(function(){
          vm.errorOccured=true;
          vm.videoUploadButtonDisabled = false;
          vm.videoUploadButtonContent = "Upload";
    });
   },
   addVideoLink(){
     var vm = this;
     var attachArray = this.$store.instructionAttachments[this.$store.currentDialogId] ? this.$store.instructionAttachments[this.$store.currentDialogId] : [];
     var link = this.videoLink;
     var data = {
          text: this.videoLink
        };
     var instructionId = this.$store.currentDialogId;
     this.$http.post("/dialogs/"+this.$store.currentDialogId+"/attachmentsText",data,
     {
       headers:{
         'index': attachArray.length
       }
     }).then(function(r){
          var obj = {
            type:"link",
            data:link,
            id:r.data.id
          };
          vm.$store.instructionAttachments = vm.$store.instructionAttachments ? vm.$store.instructionAttachments : {};
          var instAttachments = vm.$store.instructionAttachments[instructionId] ? vm.$store.instructionAttachments[instructionId] : [];
          instAttachments.push(obj); 
          vm.$set(vm.$store.instructionAttachments,instructionId,instAttachments);
          vm.updateDialog(vm.$store.currentDialogId)
       vm.$store.showUploadImageDialog=false;
     }).catch(function(){
       vm.errorOccured=true;
     });
},
  closeShowUploadImageDialog(){
      var vm=this;
      vm.$store.instructionImgselected = false;
      vm.$store.instructionVidselected = false;
      vm.$store.uploadDialogVidSrc='';
      vm.$store.answerImageUploadDialog=false;
      vm.$store.showUploadImageDialog=false;
    },

    uploadImgGalleryPictures(GalleryimgId){
      var vm = this;
      this.$http.get("/dialogs/" + this.$store.currentDialogId)
      .then(function(r){ 
        if(r.data.type == "instruction"){
          vm.$store.instructionSelected = true;
        }
        var a = r.data.attachments;
        
        vm.$store.uploadImgAttachment.forEach(function(t){
          if(t.id == GalleryimgId){

            if(vm.$store.instructionSelected){
              if(vm.$store.instructionImgselected){
                r.data.attachments.forEach(function(p,item){
                  if(p.id == vm.$store.instructionImg[0].id){
                  let deepClone = JSON.parse(JSON.stringify(t));
                  deepClone.id = vm.$store.newguidImg;
                  deepClone.index = item;
                  r.data.attachments[item] = {};
                  r.data.attachments[item] = deepClone;
                  var dialogData = r.data;
                  vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
                  .then(function(r){
                    vm.$store.showUploadImageDialog=false;
                    vm.$store.answerImageUploadDialog=false;
                    vm.$store.uploadDialogImgSrc='';
                    vm.uploadButtonDisabled = false;
                    vm.uploadButtonContent = "Upload";
                    vm.$store.imageChosen=false;
                    vm.$store.instructionSelected=false;
                    vm.$store.instructionImgselected = false;
                    vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
                    vm.$store.currentDialogRef.dialog.attachments = dialogData.attachments;
                  })
                  }
                })
              }
              else{
                if(r.data.attachments == null){
                  r.data.attachments = [];
                }
                  let deepClone = JSON.parse(JSON.stringify(t));
                  deepClone.id = vm.$store.newguidImg;
                  var a = r.data.attachments.length
                    
                    deepClone.index = a;
                  
                  r.data.attachments.push(deepClone);
                  var dialogData = r.data;
                  vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
                  .then(function(r){
                    vm.$store.showUploadImageDialog=false;
                    vm.$store.answerImageUploadDialog=false;
                    vm.$store.uploadDialogImgSrc='';
                    vm.uploadButtonDisabled = false;
                    vm.uploadButtonContent = "Upload";
                    vm.$store.imageChosen=false;
                    vm.$store.instructionSelected=false;
                    vm.$store.instructionImgselected = false;
                    vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
                    vm.$store.currentDialogRef.dialog.attachments = dialogData.attachments
                  })
                  
                }
            }
            else{
              if(r.data.attachments == null){
                  r.data.attachments = []
                  
                  let deepClone = JSON.parse(JSON.stringify(t));
                  deepClone.id = vm.$store.newguidImg;
        
                  r.data.attachments.push(deepClone) 
                  var dialogData = r.data

                  vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
                  
                  .then(function(r){
                    vm.$set(vm.$store.dialogHasAttachment,vm.$store.currentDialogId,r.data.id);
                    vm.$set(vm.$store.dialogHasImage,vm.$store.currentDialogId,vm.$store.uploadDialogImgSrc);
                    vm.$store.showUploadImageDialog=false;
                    vm.$store.answerImageUploadDialog=false;
                    vm.$store.uploadDialogImgSrc='';
                    vm.uploadButtonDisabled = false;
                    vm.uploadButtonContent = "Upload";
                    vm.$store.imageChosen=false;
                    vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
                    vm.$store.currentDialogRef.dialog.attachments = dialogData.attachments;
                  })
                }
                else{
                  if(r.data.attachments.length == 1){
                    
                    let deepClone = JSON.parse(JSON.stringify(t));
                    deepClone.id = vm.$store.newguidImg;
                    r.data.attachments[0] = deepClone;

                    var dialogData = r.data
                    vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
                    .then(function(r){
                      
                      vm.$set(vm.$store.dialogHasAttachment,vm.$store.currentDialogId,r.data.id);
                      vm.$set(vm.$store.dialogHasImage,vm.$store.currentDialogId,vm.$store.uploadDialogImgSrc);
                      vm.$store.showUploadImageDialog=false;
                      vm.$store.answerImageUploadDialog=false;
                      vm.$store.uploadDialogImgSrc='';
                      vm.uploadButtonDisabled = false;
                      vm.uploadButtonContent = "Upload";
                      vm.$store.imageChosen=false;
                      vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
                      vm.$store.currentDialogRef.dialog.attachments = dialogData.attachments;
                    })
                  }

                }
                

            }

          }
        })

      })
    },

    guidGenrator(){
      var new_uuidv4 = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
      this.$store.newguidImg = new_uuidv4;
    },

    VidguidGenrator(){
      var new_uuidv4 = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
      this.$store.newguidVid = new_uuidv4;
    },

    uploadimgSrc(src,id){
      var vm = this;
      this.$store.uploadDialogImgSrc = src
      this.$store.galleryimageId = id
      this.$store.dialogTreeGalleryStatus = false;
      
      this.imgUploadButtonDisabled = false,
      this.imgUploadButtonDisplay="block"
      this.guidGenrator();
      
    },

  galleryStatus(){
    this.$http.get("/dialogs/" + this.$store.currentDialogId)
    .then((response) => {
      if(response.data.type == "instruction"){
        this.$store.dialogTreeGalleryStatus=true;
        this.$store.videoGalleryStatus = true;
        this.$store.changeDeleteVideo = false;
        if(this.$store.instructionImgselected||this.$store.instructionVidselected){
          this.$store.dialogTreeGalleryStatus=false;
          this.$store.videoGalleryStatus = false;
          this.$store.changeDeleteVideo = true;
        }
        }else if(response.data.type == "answer"){
          if(response.data.attachments == null){
          this.$store.dialogTreeGalleryStatus=true;
          this.$store.videoGalleryStatus = false;
        }
        else{
          this.$store.dialogTreeGalleryStatus=false;
          this.$store.videoGalleryStatus = false;
        }
      }else if(response.data.type == "category"){
          if(response.data.attachments == null){
          this.$store.dialogTreeGalleryStatus=true;
          this.$store.videoGalleryStatus = false;
        }
        else{
          this.$store.dialogTreeGalleryStatus=false;
          this.$store.videoGalleryStatus = false;
        }
      } 
    })
  },

  async uploadingGalleryImages(){
    var vm = this;
    var imgBase = null;
    var resp;
    this.sampleImageArr = []
    this.$http.get('/dialogs/1/getAllAttachment?limit=20&cursor=' +this.$store.uploadDialogImgCursor)
    .then((response) => { 

       this.$store.uploadDialogImgCursor = response.data.data.cursor

      response.data.data.attachment.forEach(function(t){
        vm.$store.uploadImgAttachment.push(t)
         
         var attach = {
           id : "",
           src: "",
          }
        
        if(t.image_id != ""){
          var imageId = t.id;
          vm.$http.get('/dialogs/a/attachments/' + imageId,{
            responseType: "arraybuffer"
          }).then((r) => { 
            
            let img = btoa(new Uint8Array(r.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
            imgBase = `data:${r.headers["content-type"].toLowerCase()};base64,${img}`;
            
            attach.src = imgBase
            attach.id = imageId

            vm.$store.uploadDialogtreeImg.push(attach)
          }) 
        }
      });
    })
  },

  deleteGalleryImage(){
    var vm = this;
      this.$http.get("/dialogs/" + this.$store.currentDialogId)
      .then(function(r){
        if(r.data.type == "instruction"){
          vm.$store.instructionSelected = true;
        }
        if(r.data.attachments.length == 1){
          vm.$store.instructionSelected = false;
        }
        if(vm.$store.instructionSelected && vm.$store.instructionImgselected){
          let deepClone = JSON.parse(JSON.stringify(vm.$store.instructionImg));
          var a = 0;
          r.data.attachments.forEach(function(item,index){
            var valid = true;
            if(item.id == deepClone[0].id){
              r.data.attachments.splice(index,1)
              
              if(item.index == r.data.attachments.length){
                valid = false;
              }
            }
            if(valid){
              r.data.attachments[index].index = index;
            }
        })
        var dialogData = r.data;
         vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
         .then(function(r){
           vm.$store.showUploadImageDialog=false;
           vm.$store.answerImageUploadDialog=false;

           vm.$store.instructionSelected=false;
           vm.$store.instructionImgselected = false;
           vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
        })
      }
      else if(vm.$store.instructionSelected && vm.$store.instructionVidselected){
         let deepClone = JSON.parse(JSON.stringify(vm.$store.instructionVid));
          
          r.data.attachments.forEach(function(item,index){
            var valid = true;
            if(item.id == deepClone[0].id){
              r.data.attachments.splice(index,1)
              
              if(item.index == r.data.attachments.length){
                valid = false;
              }
            }
            if(valid){
              r.data.attachments[index].index = index;
            }
        })
        var dialogData = r.data;
         vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
         .then(function(r){
           vm.$store.showUploadImageDialog=false;
           vm.$store.answerImageUploadDialog=false;

           vm.$store.instructionSelected=false;
           vm.$store.instructionImgselected = false;
           vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
           vm.$store.uploadDialogVidSrc='';
           vm.$store.imageChosen = false;
           vm.$store.videoChosen = false;
           vm.$store.changeDeleteVideo = false;
           vm.$store.showUploadImageDialog=false;
           vm.$store.answerImageUploadDialog=false;
        })
      }
      else{
        r.data.attachments = null;
        var dialogData = r.data;
        
        vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
         .then(function(r){
        vm.$delete(vm.$store.dialogHasAttachment,vm.$store.currentDialogId);
        vm.$delete(vm.$store.dialogHasImage,vm.$store.currentDialogId);
        vm.$store.showUploadImageDialog=false;
        vm.$store.imageChosen = false;
        vm.$store.answerImageUploadDialog=false;
        
        vm.$set(vm.$store.instructionAttachments,vm.$store.currentDialogId);
        vm.$store.videoChosen = false;
        vm.$store.changeDeleteVideo = false;
        })  
      }
    })
  },

  uploadVidSrc(src,id){
      var vm = this;
      this.$store.uploadDialogVidSrc = src;
      this.$store.galleryVideoId = id
      this.$store.videoGalleryStatus = false;

      this.vidUploadButtonDisabled = false,
      this.vidUploadButtonDisplay="block"
      this.VidguidGenrator();
    },

    uploadVidfromGallery(GalleryvidId){
      var vm = this;
      this.$http.get("/dialogs/" + this.$store.currentDialogId)
      .then(function(r){ 
        if(r.data.type == "instruction"){
          vm.$store.instructionSelected = true;

        }
        var a = r.data.attachments;
        
        vm.$store.uploadVideoAttachment.forEach(function(t){
          if(t.id == GalleryvidId){

            if(vm.$store.instructionSelected){
              if(vm.$store.instructionVidselected){
                r.data.attachments.forEach(function(p,item){
                  if(p.id == vm.$store.instructionVid[0].id){
                  let deepClone = JSON.parse(JSON.stringify(t));
                  deepClone.id = vm.$store.newguidVid;
                  deepClone.index = item;
                  r.data.attachments[item] = {};
                  r.data.attachments[item] = deepClone;
                  var dialogData = r.data;

                  vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
                  .then(function(response){
                    vm.$store.showUploadImageDialog=false;
                    vm.$store.answerImageUploadDialog=false;
                    vm.vidUploadButtonDisabled = false;
                    vm.$store.uploadDialogVidSrc = "";
                    vm.$store.instructionSelected = false;
                    vm.$store.instructionVidselected = false;
                    vm.$store.videoChosen = false;
                    vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
                    vm.$store.currentDialogRef.dialog.attachments = dialogData.attachments;
                  })
                  }
                })
              }
              else{
                if(r.data.attachments == null){
                  r.data.attachments = [];
                }
                  let deepClone = JSON.parse(JSON.stringify(t));
                  deepClone.id = vm.$store.newguidVid;
                  var a = r.data.attachments.length
                    
                    deepClone.index = a;
                  
                  r.data.attachments.push(deepClone);
                  var dialogData = r.data;
                  vm.$http.put("/dialogs/" + vm.$store.currentDialogId, dialogData)
                  .then(function(r){

                    vm.$store.showUploadImageDialog=false;
                    vm.$store.answerImageUploadDialog=false;
                    vm.vidUploadButtonDisabled = false;
                    vm.$store.uploadDialogVidSrc = "";
                    vm.$store.instructionSelected = false;
                    vm.$store.instructionVidselected = false;
                    vm.$store.videoChosen = false;
                    vm.$store.changeDeleteVideo = false;
                    vm.$store.currentDialogRef.$parent.getDialogByID(vm.$store.currentDialogRef.dialog.id);
                    vm.$store.currentDialogRef.dialog.attachments = dialogData.attachments;

                  }).catch(function(){
                    vm.errorOccured=true;
                    vm.vidUploadButtonDisabled = false;
          })
                  
                }
            }
          }
        })

      })
    },

  async uploadingGalleryVideo(){
    var vm = this;
    var vidBase = null;
    var resp;
    
    this.$http.get('/dialogs/1/getAllAttachment?limit=50&cursor=' +this.$store.uploadDialogVidCursor)
    .then((response) => { 

       this.$store.uploadDialogVidCursor = response.data.data.cursor

      response.data.data.attachment.forEach(function(t){
        vm.$store.uploadVideoAttachment.push(t)
         
         var attach = {
           id : "",
           src: "",
          }
          if(t.contentType == "video/mp4"){
            var vidId = t.id;
      
            vm.$http.get('/dialogs/a/attachments/' + vidId,{
            responseType: "arraybuffer"
          }).then((r) => { 
            
            let vid = btoa(new Uint8Array(r.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
            vidBase = `data:${r.headers["content-type"].toLowerCase()};base64,${vid}`;
            
            attach.src = vidBase
            attach.id = vidId

            vm.$store.uploadDialogtreeVid.push(attach)
          }) 
          }
      });
    })
    
  },

  }
}
</script>

<style scoped>
.changevid{
  margin-left: 100px;
}
.changeimg{
  margin-left: 100px;
}
.upload-image-body{
  width: 280px;
}

#video-player{
	width: 250px;
	height: 150px;
  margin-top: 20px;
}

.overlay{
width:100vw;
height:100vh;
position:fixed;
top:0;
left:0;
background:rgba(0,0,0,.4);
z-index:999;
cursor:initial;
}
.upload-image-wrapper{
box-shadow:2px 2px 3px #888;
left:calc(50% - 150px);
top:calc(50% - 250px);
margin:-8px;
width:300px;
position:fixed;
padding:10px;
text-align:center;
align-content: center;
color:dimgray;
background:#f7f7f7;
z-index:10;
animation: grow .25s;
}

@keyframes grow {
  from {
    transform: scale(0.75) ;
  }
  to {
    transform:  scale(1) ;
  }
}

.close{
width:20px;
height:20px;
position:absolute;
right:5px;
top:0px;
}
.close button{
background:none;
border:0px;
font-weight:600;
}
 button:hover{
cursor:pointer;
color: red;
}
.upload-image-head,.update-image-head{
padding:10px;
font-size:22px;
}

.upload-image-buttons button, .upload-video-buttons button{
 border:0px;
 color:white;
 padding:10px 0px;
 width:80%;
 background:#0098ff;
 left:10%;
 position:relative;
}

.upload-video-buttons button{
  margin-top: 20px;
}

.delete-change-image-buttons, .delete-change-video-buttons{
display:inline;
}
.delete-change-image-buttons button, .delete-change-video-buttons button{
border:0px;
color:white;
padding:10px 0px;
background:#0098ff;
}

.delete-change-image-buttons button{
  width:40%;
}

.delete-change-video-buttons button{
  width:80%;
}

#video-link-inputbox{
  width: 80%;
  left: 10%;
  margin-top: 30px;
}

#video-link-input{
  width: 80%;
  border-bottom-color: #0098ff;
}

#video-link-inputbox label{
  color: #0098ff;
}

.video-link-add-btn{
  padding-left:5px; 
  padding-right:5px; 
  float:right; 
  margin-top:10px;
  background-color: #0098ff;
}

.video-link-add-btn:hover{
  background-color: #0098ff;
}
</style>
